/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník všech podporovaných platforem.
 * Platforma představuje prostředí, ve kterém se aplikace spouští.
 * Platforma určuje dostupné funkcionality, kterých může aplikace využít.
 * @enum {string}
 */
const Platform = {
  /** Platforma Ki-Wi Lighter API. */
  KiwiLighter1: 'KiwiLighter1',
  /** Platforma Samsung Smart Signage Platform ve verzi 4. */
  TizenSssp4: 'TizenSssp4',
  /** Platforma Samsung Smart Signage Platform ve verzi 5. */
  TizenSssp5: 'TizenSssp5',
  /** Platforma Samsung Smart Signage Platform ve verzi 6. */
  TizenSssp6: 'TizenSssp6',
  /** Platforma standardních webových technologií. */
  Web: 'Web',
  /** Platforma LG webOS Smart Signage Platform ve verzi 3.0. */
  WebosSignage3_0: 'WebosSignage3_0',
  /** Platforma LG webOS Smart Signage Platform ve verzi 3.2. */
  WebosSignage3_2: 'WebosSignage3_2',
  /** Platforma LG webOS Smart Signage Platform ve verzi 4.0. */
  WebosSignage4_0: 'WebosSignage4_0',
  /** Platforma LG webOS Smart Signage Platform ve verzi 4.1. */
  WebosSignage4_1: 'WebosSignage4_1'
};

export default Platform;
